import * as Connector from 'shared/connectors/investorsConnector';
import { INVESTOR } from 'store/types';

const init = () => ({
  type: INVESTOR.GET_INVESTORS_LABEL_INIT,
});

export const success = data => ({
  type: INVESTOR.GET_INVESTORS_LABEL_SUCCESS,
  payload: {
    data,
  },
});

const failure = () => ({
  type: INVESTOR.GET_INVESTORS_LABEL_FAILURE,
});

const getInvestorsLabel = form => async dispatch => {
  dispatch(init());
  try {
    const { data } = await Connector.getInvestorsLabel(form);
    dispatch(success(data));
  } catch (err) {
    dispatch(failure());
  }
};

export default getInvestorsLabel;
